import type { ReactNode } from 'react';
import React from 'react';
import cx from 'classnames';

import styles from './ProductFooter.module.scss';

export const ProductFooter: React.FC<{ actions?: ReactNode; className: string; title: ReactNode }> = ({
	actions = null,
	className,
	title,
}) => {
	return (
		<aside className={cx(styles.component, className)}>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<h2>{title}</h2>
					{actions && <footer>{actions}</footer>}
					<svg
						className={styles.arrow}
						fill="none"
						height="250"
						preserveAspectRatio="none"
						viewBox="0 0 68 250"
						width="68"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M.64 249.37V.64h3.24c2.7 0 5.15 1.55 6.31 3.99L65.88 122a7 7 0 0 1 0 6L10.19 245.36a6.99 6.99 0 0 1-6.31 4H.64Z"
							stroke="var(--product-accent)"
							strokeWidth="1"
							vectorEffect="non-scaling-stroke"
						/>
					</svg>
				</div>
			</div>
		</aside>
	);
};
